module.exports = __webpack_public_path__ + "img/fa-brands-400.3c45c98.svg";